window.addEventListener('mousemove', e => {
  Mouse.x = e.clientX
  Mouse.y = e.clientY
  Mouse.rx = e.clientX / window.innerWidth * 2 - 1
  Mouse.ry = e.clientY / window.innerHeight * 2 - 1
})

export const Mouse = {
  x: 0,
  y: 0,
  rx: 0,
  ry: 0
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/MouseHelper.js